import { FlexRow } from 'ui-components/components/flex';
import FormattedCurrency from '../../../../../../components/formatted-currency';
import { modalMessages } from '../messages';
import { PlanLineItemDetail } from './plan-line-item-detail';
import style from '../migration-plan-modal.module.less';

export const PlanCard = ({ planDetails = {}, promotionalPrice }) => {
  const promotionalLineItemValue = promotionalPrice ? (
    <FormattedCurrency currencyCode={planDetails.promotionalPricePerMonth?.code} value={promotionalPrice} />
  ) : null;

  return (
    <FlexRow className={style['line-item-row']}>
      <PlanLineItemDetail
        lineItemTitle={modalMessages.monthlyCost}
        lineItemValue={<FormattedCurrency currencyCode={planDetails.pricePerMonth?.code} value={planDetails.pricePerMonth?.value} />}
        promotionalLineItemValue={promotionalLineItemValue}
      />
      <PlanLineItemDetail lineItemTitle={modalMessages.shipments} lineItemValue={planDetails.shipmentLimit?.limit} />
      <PlanLineItemDetail lineItemTitle={modalMessages.users} lineItemValue={planDetails.userLimit?.limit} />
    </FlexRow>
  );
};
